import { render } from "./tagSelectDialog.vue?vue&type=template&id=e2901636"
import script from "./tagSelectDialog.vue?vue&type=script&lang=js"
export * from "./tagSelectDialog.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__